import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e266b1e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-input" }
const _hoisted_2 = { class: "input-wrapper" }
const _hoisted_3 = { class: "button-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-send" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-content" }, "c")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-abort" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-content" }, "c")
], -1))

import { ref } from 'vue'

// 发送消息消息事件

export default /*#__PURE__*/_defineComponent({
  __name: 'MessageInput',
  props: {
  senMessageEnable: { type: Boolean ,deault: true ,required: true},
},
  emits: ["send", "abort", "setMode"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit

//设置属性
const props = __props

// 输入框内的消息
const messageText = ref('')
//是否为知识查询模式
const knowledgeQuery = ref(true);

const popoverRef = ref({} as any);
const messageInputRef = ref({} as any);

//向父组件暴露
__expose({messageInputRef});

//处理回车事件，实现换行和发送消息
const handleKeydownEnter = (event: KeyboardEvent) => {
    event.preventDefault();
    if (event.ctrlKey || event.shiftKey) {
      messageText.value += '\n'; // 插入换行符
    }
    else{
      sendMessage();
    }
}

const sendMessage = () => {
  var messageTrim:string = messageText.value.trim();
    if(messageTrim.length > 0 && props.senMessageEnable)
    {
        emit('send', messageText.value)
        // 发送完清除
        messageText.value = ''
    }
}

const setKnowledgeQuery = (value:boolean)=>{
  knowledgeQuery.value = value;
  
  if(popoverRef.value)
  {
    popoverRef.value.hide();
  }
  emit('setMode',knowledgeQuery.value);
}

const abortMessage = () => {
    emit('abort');    
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: messageText.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((messageText).value = $event)),
        ref_key: "messageInputRef",
        ref: messageInputRef,
        id: "messageInputId",
        autosize: false,
        rows: 3,
        class: "input",
        resize: "none",
        type: "textarea",
        placeholder: _ctx.$t('input.preWorld'),
        onKeydown: _withKeys(handleKeydownEnter, ["enter"])
      }, null, 8, ["modelValue", "placeholder"]),
      _createElementVNode("div", _hoisted_3, [
        (__props.senMessageEnable)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "send-button",
              icon: "el-icon-send",
              onClick: sendMessage,
              disabled: !messageText.value.trim()
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["disabled"]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              class: "abort-button",
              icon: "el-icon-abort",
              onClick: abortMessage
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }))
      ])
    ])
  ]))
}
}

})